import _Fullscreen from "@mui/icons-material/Fullscreen";
import _FullscreenExit from "@mui/icons-material/FullscreenExit";
import React from 'react';
import { ButtonContainer, getShadowIconStyles, IconButtonLabel, IconButtonWrapper } from 'app/components/tv/customControls/SharedCustomControlsStyles';
import { getFullScreenElement, useFullscreen } from 'app/hooks/useFullscreen';
export const FullscreenButton = () => {
  const {
    fullscreen,
    requestFullscreen,
    exitFullscreen
  } = useFullscreen();
  const handleFullscreen = () => {
    if (getFullScreenElement(document)) {
      exitFullscreen();
    } else {
      const elem = document.documentElement;
      requestFullscreen(elem);
    }
  };
  return /*#__PURE__*/React.createElement(IconButtonWrapper, {
    "data-sentry-element": "IconButtonWrapper",
    "data-sentry-component": "FullscreenButton",
    "data-sentry-source-file": "FullscreenButton.tsx"
  }, /*#__PURE__*/React.createElement(ButtonContainer, {
    onClick: handleFullscreen,
    title: 'Vollbild',
    noMargin: true,
    "data-sentry-element": "ButtonContainer",
    "data-sentry-source-file": "FullscreenButton.tsx"
  }, fullscreen ? /*#__PURE__*/React.createElement(_FullscreenExit, {
    style: getShadowIconStyles()
  }) : /*#__PURE__*/React.createElement(_Fullscreen, {
    style: getShadowIconStyles()
  })), /*#__PURE__*/React.createElement(IconButtonLabel, {
    variant: "body1",
    "data-sentry-element": "IconButtonLabel",
    "data-sentry-source-file": "FullscreenButton.tsx"
  }, "Vollbild"));
};